<div class="transfer-container">
  <div class="transfer-topbar">
    <div class="topbar-left">
      <h1>
        Stock Transfers
        <small>Manage inventory movement between locations</small>
      </h1>
      <div class="breadcrumb">
        <i class="bi bi-house-door"></i> <span>Inventory</span> /
        <span class="current">Stock Transfers</span>
        <span class="separator">|</span>
        <span class="time"><i class="bi bi-clock"></i> {{ timestamp() }}</span>
      </div>
    </div>
    <div class="topbar-right">
      <div class="search-box">
        <i class="bi bi-search"></i>
        <input
          type="text"
          placeholder="Search transfers..."
          [ngModel]="search()"
          (ngModelChange)="search.set($event); onSearchChange()"
        />
      </div>
      <button class="btn btn-outline btn-sm" type="button" (click)="exportData()">
        <i class="bi bi-download"></i> Export
      </button>
      <button class="btn btn-primary" type="button" (click)="openTransferModal()">
        <i class="bi bi-plus-circle"></i> New Transfer
      </button>
    </div>
  </div>

  <div class="stats-row">
    <div class="stat-card">
      <div class="stat-icon blue"><i class="bi bi-arrow-left-right"></i></div>
      <div class="stat-info">
        <div class="stat-label">Total Transfers</div>
        <div class="stat-value">{{ stats().total }}</div>
      </div>
    </div>
    <div class="stat-card">
      <div class="stat-icon green"><i class="bi bi-check-circle"></i></div>
      <div class="stat-info">
        <div class="stat-label">Completed</div>
        <div class="stat-value">{{ stats().completed }}</div>
      </div>
    </div>
    <div class="stat-card">
      <div class="stat-icon amber"><i class="bi bi-clock"></i></div>
      <div class="stat-info">
        <div class="stat-label">Pending / In Transit</div>
        <div class="stat-value">{{ stats().inTransit }}</div>
      </div>
    </div>
    <div class="stat-card">
      <div class="stat-icon red"><i class="bi bi-x-circle"></i></div>
      <div class="stat-info">
        <div class="stat-label">Cancelled</div>
        <div class="stat-value">{{ stats().cancelled }}</div>
      </div>
    </div>
  </div>

  <div class="filter-bar">
    <div class="filter-left">
      <div class="filter-group">
        <label><i class="bi bi-building"></i> {{ branchFilterLocked() ? 'Branch' : 'From Branch' }}</label>
        <select
          [ngModel]="fromBranchFilter()"
          (ngModelChange)="fromBranchFilter.set($event); onFilterChange()"
        >
          @if (!branchFilterLocked()) {
            <option value="all">All Branches</option>
          }
          @for (branch of fromBranches(); track branch.id) {
            <option [value]="branch.id">{{ branch.name }}</option>
          }
        </select>
      </div>
      <div class="filter-group">
        <label><i class="bi bi-building"></i> To Branch</label>
        <select
          [ngModel]="toBranchFilter()"
          (ngModelChange)="toBranchFilter.set($event); onFilterChange()"
        >
          <option value="all">All Branches</option>
          @for (branch of toBranches(); track branch.id) {
            <option [value]="branch.id">{{ branch.name }}</option>
          }
        </select>
      </div>
      <div class="filter-group">
        <label><i class="bi bi-check-circle"></i> Status</label>
        <select
          [ngModel]="statusFilter()"
          (ngModelChange)="statusFilter.set($event); onFilterChange()"
        >
          <option value="all">All Status</option>
          <option value="pending">Pending</option>
          <option value="in-transit">In Transit</option>
          <option value="completed">Completed</option>
          <option value="cancelled">Cancelled</option>
        </select>
      </div>
    </div>
    <div class="filter-right">
      <span class="filter-count">Showing {{ filteredTransfers().length }} of {{ branchVisibleTransfers().length }}</span>
      <button type="button" class="btn btn-outline btn-sm" (click)="clearFilters()">
        Clear filters
      </button>
    </div>
  </div>


  <div class="table-wrap">
    <div class="table-scroll">
      <table>
        <thead>
          <tr>
            <th>Transfer ID</th>
            <th>From Branch</th>
            <th>From Storage</th>
            <th>To Branch</th>
            <th>To Storage</th>
            <th>Items</th>
            <th>Date</th>
            <th>Status</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          @for (row of paginatedTransfers(); track row.id) {
            <tr>
              <td><span class="transfer-id">{{ row.transferNumber }}</span></td>
              <td>{{ getFromBranch(row) }}</td>
              <td>{{ getFromStorage(row) }}</td>
              <td>{{ getToBranch(row) }}</td>
              <td>{{ getToStorage(row) }}</td>
              <td>{{ getItemsLabel(row) }}</td>
              <td>{{ formatDate(row.transferDate) }}</td>
              <td>
                <span
                  class="status-badge"
                  [class.completed]="row.status === 'completed'"
                  [class.pending]="row.status === 'pending'"
                  [class.in-transit]="row.status === 'in-transit'"
                  [class.cancelled]="row.status === 'cancelled'"
                >
                  {{ statusLabel(row.status) }}
                </span>
              </td>
              <td class="actions-cell">
                <div class="row-actions">
                  <button
                    type="button"
                    class="btn-action edit"
                    title="Edit transfer"
                    (click)="openEditModal(row); $event.stopPropagation()"
                  >
                    <i class="bi bi-pencil"></i>
                  </button>
                  @if (row.status === 'pending' || row.status === 'in-transit') {
                    <button
                      type="button"
                      class="btn-action complete"
                      title="Complete transfer (moves stock)"
                      [disabled]="saving()"
                      (click)="completeTransfer(row, $event)"
                    >
                      <i class="bi bi-check-circle"></i>
                    </button>
                  }
                  @if (row.status !== 'cancelled') {
                    <button
                      type="button"
                      class="btn-action cancel"
                      title="Cancel transfer"
                      [disabled]="saving()"
                      (click)="cancelTransfer(row, $event)"
                    >
                      <i class="bi bi-x-circle"></i>
                    </button>
                  }
                </div>
              </td>
            </tr>
          } @empty {
            <tr>
              <td colspan="9" class="empty-cell">No stock transfers found.</td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  </div>

  <div class="pagination-bar">
    <div class="pagination-info">
      Showing <span>{{ paginationStart() }}</span> to <span>{{ paginationEnd() }}</span> of
      <span>{{ filteredTransfers().length }}</span> transfers
    </div>
    <div class="pagination-controls">
      <button
        class="btn btn-outline btn-sm"
        type="button"
        [disabled]="page() === 1"
        (click)="goToPage(page() - 1)"
      >
        <i class="bi bi-chevron-left"></i> Previous
      </button>
      @for (p of pageNumbers(); track p) {
        <button
          class="btn btn-sm"
          type="button"
          [class.btn-primary]="page() === p"
          [class.btn-outline]="page() !== p"
          (click)="goToPage(p)"
        >
          {{ p }}
        </button>
      }
      <button
        class="btn btn-outline btn-sm"
        type="button"
        [disabled]="page() === totalPages()"
        (click)="goToPage(page() + 1)"
      >
        Next <i class="bi bi-chevron-right"></i>
      </button>
    </div>
  </div>
</div>

<div class="modal-overlay" [class.open]="showModal()" (click)="closeModalOnBackdrop($event)">
  <div class="modal modal-large" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <h2>
        <i class="bi" [class]="editingTransfer() ? 'bi-pencil' : 'bi-plus-circle'"></i>
        {{ editingTransfer() ? 'Edit Stock Transfer' : 'New Stock Transfer' }}
      </h2>
      <button class="close-btn" type="button" (click)="closeModal()">
        <i class="bi bi-x-lg"></i>
      </button>
    </div>

    <div class="modal-body">
      @if (editingTransfer(); as editRow) {
        <p class="modal-hint">
          Transfer <strong>{{ editRow.transferNumber }}</strong> —
          Completing moves stock; cancelling a completed transfer restores quantities.
          Lines cannot be changed after create.
        </p>
        <div class="form-row">
          <div class="form-group">
            <label>Items</label>
            <input type="text" [value]="getItemsLabel(editRow)" readonly />
          </div>
          <div class="form-group">
            <label>Route</label>
            <input
              type="text"
              [value]="getFromBranch(editRow) + ' → ' + getToBranch(editRow)"
              readonly
            />
          </div>
        </div>
        <div class="form-row">
          <div class="form-group">
            <label>Transfer Date</label>
            <input
              type="date"
              [ngModel]="form().transferDate"
              (ngModelChange)="updateForm('transferDate', $event)"
            />
          </div>
          <div class="form-group">
            <label>Status <span class="required">*</span></label>
            <select [ngModel]="form().status" (ngModelChange)="updateForm('status', $event)">
              <option value="pending">Pending</option>
              <option value="in-transit">In Transit</option>
              <option value="completed">Completed</option>
              <option value="cancelled">Cancelled</option>
            </select>
          </div>
        </div>
        <div class="form-row">
          <div class="form-group full">
            <label>Notes</label>
            <input
              type="text"
              placeholder="Optional notes"
              [ngModel]="form().notes"
              (ngModelChange)="updateForm('notes', $event)"
            />
          </div>
        </div>
      } @else {
        <div class="section-title"><i class="bi bi-arrow-right-circle"></i> From</div>
        <div class="form-row">
          <div class="form-group">
            <label>From Branch <span class="required">*</span></label>
            <select
              [ngModel]="form().fromBranchId"
              (ngModelChange)="onFromBranchChange($event)"
              [disabled]="branchFilterLocked()"
            >
              <option value="">Select Branch</option>
              @for (branch of fromBranches(); track branch.id) {
                <option [value]="branch.id">{{ branch.name }}</option>
              }
            </select>
          </div>
          <div class="form-group">
            <label>From Location <span class="required">*</span></label>
            <select
              [ngModel]="form().fromLocationId"
              (ngModelChange)="onFromLocationChange($event)"
            >
              <option value="">Select Location</option>
              @for (loc of fromLocations(); track loc.id) {
                <option [value]="loc.id">{{ loc.name }}</option>
              }
            </select>
          </div>
        </div>

        <div class="section-title"><i class="bi bi-arrow-left-circle"></i> To</div>
        <div class="form-row">
          <div class="form-group">
            <label>To Branch <span class="required">*</span></label>
            <select
              [ngModel]="form().toBranchId"
              (ngModelChange)="onToBranchChange($event)"
            >
              <option value="">Select Branch</option>
              @for (branch of toBranches(); track branch.id) {
                <option [value]="branch.id">{{ branch.name }}</option>
              }
            </select>
          </div>
          <div class="form-group">
            <label>To Location <span class="required">*</span></label>
            <select
              [ngModel]="form().toLocationId"
              (ngModelChange)="updateForm('toLocationId', $event)"
            >
              <option value="">Select Location</option>
              @for (loc of toLocations(); track loc.id) {
                <option [value]="loc.id">{{ loc.name }}</option>
              }
            </select>
            @if (form().fromBranchId && form().toBranchId === form().fromBranchId && toLocations().length < 2) {
              <small class="field-hint">Add another store location at this branch to transfer stock between locations.</small>
            }
          </div>
        </div>

        <div class="section-title"><i class="bi bi-box-seam"></i> Items</div>
        <div class="item-picker">
          <div class="form-row">
            <div class="form-group grow">
              <label>Item</label>
              <input
                type="text"
                placeholder="Filter items..."
                [ngModel]="itemSearch()"
                (ngModelChange)="itemSearch.set($event)"
              />
              <select [ngModel]="selectedItemId()" (ngModelChange)="selectedItemId.set($event)">
                <option value="">Select item with stock</option>
                @for (item of availableItems(); track item.id) {
                  <option [value]="item.id">
                    {{ item.code }} — {{ item.name }} ({{ item.available }} avail.)
                  </option>
                }
              </select>
            </div>
            <div class="form-group qty-group">
              <label>Qty</label>
              <input
                type="number"
                min="1"
                step="1"
                appDigitsOnly
                [ngModel]="selectedQty()"
                (ngModelChange)="onSelectedQtyChange($event)"
              />
            </div>
            <div class="form-group add-group">
              <label>&nbsp;</label>
              <button class="btn btn-outline" type="button" (click)="addLine()">
                <i class="bi bi-plus-lg"></i> Add
              </button>
            </div>
          </div>
        </div>

        @if (lines().length) {
          <div class="lines-table-wrap">
            <table class="lines-table">
              <thead>
                <tr>
                  <th>Code</th>
                  <th>Item</th>
                  <th>Qty</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                @for (line of lines(); track line.itemId; let i = $index) {
                  <tr>
                    <td>{{ line.code }}</td>
                    <td>{{ line.name }}</td>
                    <td>{{ line.quantity }}</td>
                    <td>
                      <button
                        type="button"
                        class="btn-action cancel"
                        title="Remove line"
                        (click)="removeLine(i)"
                      >
                        <i class="bi bi-trash"></i>
                      </button>
                    </td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
        } @else {
          <p class="empty-lines">No items added yet.</p>
        }

        <div class="form-row">
          <div class="form-group">
            <label>Transfer Date <span class="required">*</span></label>
            <input
              type="date"
              [ngModel]="form().transferDate"
              (ngModelChange)="updateForm('transferDate', $event)"
            />
          </div>
          <div class="form-group">
            <label>Reference</label>
            <input
              type="text"
              placeholder="Optional reference"
              [ngModel]="form().referenceNumber"
              (ngModelChange)="updateForm('referenceNumber', $event)"
            />
          </div>
        </div>
        <div class="form-row">
          <div class="form-group full">
            <label>Notes</label>
            <input
              type="text"
              placeholder="Optional notes"
              [ngModel]="form().notes"
              (ngModelChange)="updateForm('notes', $event)"
            />
          </div>
        </div>
        <p class="modal-hint">
          Send stock to another branch in your company, or between store locations.
          Complete the transfer to move quantity.
        </p>
      }
    </div>

    <div class="modal-footer">
      <button class="btn btn-outline" type="button" (click)="closeModal()">Cancel</button>
      <button
        class="btn btn-primary"
        type="button"
        [disabled]="saving() || (!editingTransfer() && lines().length === 0)"
        (click)="saveTransfer()"
      >
        <i class="bi bi-check-lg"></i>
        {{ editingTransfer() ? 'Save Changes' : 'Create Transfer' }}
      </button>
    </div>
  </div>
</div>

<div class="toast-container" [class.show]="showToast()">
  <div
    class="toast"
    [class.success]="toastType() === 'success'"
    [class.error]="toastType() === 'error'"
    [class.info]="toastType() === 'info'"
  >
    <div class="toast-icon">
      @if (toastType() === 'error') {
        <i class="bi bi-x-circle-fill"></i>
      } @else if (toastType() === 'info') {
        <i class="bi bi-info-circle-fill"></i>
      } @else {
        <i class="bi bi-check-circle-fill"></i>
      }
    </div>
    <div class="toast-content">
      <div class="toast-title">
        @if (toastType() === 'error') {
          Error
        } @else if (toastType() === 'info') {
          Info
        } @else {
          Success
        }
      </div>
      <div class="toast-message">{{ toastMessage() }}</div>
    </div>
    <button class="toast-close" type="button" (click)="closeToast()">
      <i class="bi bi-x"></i>
    </button>
  </div>
</div>
